<template>
    <th @click.stop="updateSort" :data-label="label">
        <div>
            <span>
                <slot>{{ label }}</slot>
            </span>
            <div class="arrows unselectable" v-if="field && sortable">
                <i :class="{ 'material-icons': true, active: upArrowActive }">arrow_drop_up</i>
                <i :class="{ 'material-icons': true, active: downArrowActive }">arrow_drop_down</i>
            </div>
        </div>
    </th>
</template>
<script setup>
import { computed } from 'vue'

const props = defineProps({
    field: {
        type: String,
        required: false,
    },
    label: {
        type: String,
        required: false,
    },
    sort: {
        type: Object,
        required: false,
    },
    sortable: {
        type: Boolean,
        default: true,
    },
})

const emit = defineEmits(['update:sort'])

const current = computed(() => (props.sort?.field === props.field ? props.sort?.direction ?? 'asc' : null))
const upArrowActive = computed(() => current.value === 'asc')
const downArrowActive = computed(() => current.value === 'desc')

function updateSort() {
    if (current.value === 'asc') {
        emit('update:sort', { field: props.field, direction: 'desc' })
    } else {
        emit('update:sort', { field: props.field, direction: 'asc' })
    }
}
</script>
<style scoped>
th > div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;

    > span {
        flex-grow: 1;
    }
}

.arrows {
    border-radius: 12px;
    height: 24px;
    width: 24px;
    position: relative;

    &:hover {
        background-color: var(--color-primary-200);
    }

    &:hover .material-icons {
        color: var(--color-primary-300);
    }

    &:hover .material-icons.active {
        color: var(--color-primary-700);
    }
}

.material-icons {
    line-height: 12px;
    cursor: pointer;
    left: 0px;
    position: absolute;
    font-size: var(--font-size-breadcrumbs);
    color: var(--color-primary-200);

    &:first-child {
        top: 2px;
    }
    &:last-child {
        bottom: 2px;
    }

    &.active {
        color: var(--color-primary-600);
    }
}
</style>
